import { createReducer } from '@reduxjs/toolkit';
import { getActionStringWithoutState } from '@redux/reduxUtils';
import {
  getLLMPromptsActions,
  getLLMPromptByIdActions,
  createLLMPromptActions,
  updateLLMPromptActions,
  deleteLLMPromptActions,
  clearLLMPromptsErrorAction,
  clearLLMPromptsSuccessAction
} from './llmPromptsActions';
import { LLMPromptsState } from './llmPromptsTypes';

export const initialLLMPromptsState: LLMPromptsState = {
  isLoading: {},
  error: {},
  success: {},
  llmPromptsById: {}
};

export default createReducer(initialLLMPromptsState, (builder) => {
  // Get all LLM prompts
  builder.addCase(getLLMPromptsActions.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(getLLMPromptsActions.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    // Populate with new data
    action.payload?.forEach((prompt) => {
      state.llmPromptsById[prompt.id] = prompt;
    });
  });
  builder.addCase(getLLMPromptsActions.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });

  // Get LLM prompt by ID
  builder.addCase(getLLMPromptByIdActions.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(getLLMPromptByIdActions.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    if (action.payload?.id) {
      state.llmPromptsById[action.payload.id] = action.payload;
    }
  });
  builder.addCase(getLLMPromptByIdActions.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });

  // Create LLM prompt
  builder.addCase(createLLMPromptActions.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(createLLMPromptActions.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    if (action.payload?.id) {
      state.llmPromptsById[action.payload.id] = action.payload;
    }
  });
  builder.addCase(createLLMPromptActions.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });

  // Update LLM prompt
  builder.addCase(updateLLMPromptActions.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(updateLLMPromptActions.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    if (action.payload?.id) {
      state.llmPromptsById[action.payload.id] = action.payload;
    }
  });
  builder.addCase(updateLLMPromptActions.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });

  // Delete LLM prompt
  builder.addCase(deleteLLMPromptActions.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(deleteLLMPromptActions.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    const promptId = action.payload;
    if (promptId) {
      delete state.llmPromptsById[promptId];
    }
  });
  builder.addCase(deleteLLMPromptActions.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });

  // Clear error and success
  builder.addCase(clearLLMPromptsErrorAction, (state) => {
    state.error = {};
  });
  builder.addCase(clearLLMPromptsSuccessAction, (state) => {
    state.success = {};
  });
});
